<div ng-if="editor.isDesigning()" ng-show="isDragged" class="shadow"></div>
<c-form-element-actions ng-if="editor.isDesigning()" editor="editor" element="field"></c-form-element-actions>
<label ng-class="{selectable:editor.isDesigning()}" ng-mousedown="editor.dragBegin(field, $event)" title="{{(editor.isDesigning() ? 'move':'')|translate}}" ng-bind-html="labelText"></label>
<span class="field-description" ng-if="!tool" ng-bind-html="descriptionText"></span>
<div>
    <ul ng-if="!tool&& items.length > 0">
        <li ng-repeat="item in items track by item.Id | orderBy: 'endDate'">
            <c-list-item options="listOptions" render-item-as="template" item="item"></c-list-item>
        </li>
    </ul>
    <div class="no-tasks" ng-if="!tool && items.length === 0">
        {{'no.attached.tasks'|translate}}
    </div>
    <div class="no-tasks" ng-if="tool">
        ...
    </div>
</div>